import { ConversionTableValue } from './conversion-table-value';

export class ConversionTableRow {

    constructor() {
        this.Values = [];
    }

    RowId?: number;
    ConversionTableId?: number;
    RowNumber: number;
    IsDefault: boolean;
    PartnersId?: number;
    Values: ConversionTableValue[];
}